import { gsap } from "gsap";

export default function () {
    const quoteTimeline = gsap.timeline()
    if (!document.querySelector('[data-block="quote"]'))
        return quoteTimeline

    const heroFadeOut = gsap.timeline({
            scrollTrigger: {
                trigger: '[data-block="quote"]',
                start: 'top bottom',
                end: 'bottom bottom',
                scrub: true
            }
        }),
        quoteEntry = gsap.timeline({
            scrollTrigger: {
                trigger: '[data-block="quote"]',
                start: 'top 68%',
                end: 'bottom bottom',
                scrub: true,
                snap: {
                    snapTo: [0, 1],
                    delay: 0.08,
                    duration: {
                        min: 0.2,
                        max: 1.6
                    }
                }
            }
        }),
        quoteProgress = gsap.timeline({
            scrollTrigger: {
                trigger: '[data-block="quote"]',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        })

    heroFadeOut.fromTo('[data-block="hero-bg"]', { scale: 1.2 }, { scale: 1 })
        .to('[data-block="hero-heading"]', { y: '48vh' }, '<')
        .to('[data-block="hero-content"]', { y: '40vh' }, '<')

    quoteEntry.to('[data-block="hero"]', { opacity: 0 })
        .to('[data-block="header"]', { opacity: 0, yPercent: -100 }, '<')
        .from('[data-block="quote"]', { opacity: 0 }, '<')

    quoteProgress.from('[data-block="quote-photo"]', { yPercent: -120 })

    quoteTimeline
        .add(heroFadeOut)
        .add(quoteEntry)
        .add(quoteProgress)

    return quoteTimeline
}